/**
 * Checks if a given string can be converted to a number.
 * @param value - The string to check.
 * @returns True if the string can be converted to a number, false otherwise.
 */
const stringIsNumber = (value: string): boolean =>
  isNaN(Number(value)) === false;

/**
 * Converts an enum object to an array of its values.
 * @param enumObj - The enum object to convert.
 * @returns An array of the enum object's values.
 */
export const enumToArray = (enumObj: any) => {
  return Object.keys(enumObj).map(key => enumObj[key]);
};

/**
 * Checks if all values of a given key in an array of objects are null.
 * @param arr - The array of objects to check.
 * @param key - The key to check for null values.
 * @returns True if all values of the given key are null, false otherwise.
 */
export function areAllKeyValuesNull(arr: any[], key: string) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key] !== null) {
      return false;
    }
  }
  return true;
}

export function generateRandomString(length: number): string {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
}
